<template>
  <div>
    <navbarBox />
    <showdatatorcomponents />
  </div>
</template>

<script>
import navbarBox from "../components/navbarBox";
import showdatatorcomponents from "@/components/showdatatorcomponents.vue";
export default {
  components: { showdatatorcomponents, navbarBox },
};
</script>
